import Card from "./card.js";
export default class ControlCard extends Card {
  constructor(l, t, s, i, n, r) {
    super(l, t, null, null, null, null, s, null, i, null, null, null, n, r),
      (this.isControl = !0),
      (this.U = "ab-control-card"),
      (this.V = !1);
  }
  ss() {
    const l = {};
    return (
      (l[Card.hs.ts] = Card.es.At),
      (l[Card.hs.ns] = this.id),
      (l[Card.hs.ls] = this.viewed),
      (l[Card.hs.us] = this.updated),
      (l[Card.hs.ds] = this.expiresAt),
      (l[Card.hs.xs] = this.extras),
      (l[Card.hs.gs] = this.pinned),
      (l[Card.hs.zs] = this.test),
      l
    );
  }
}
